<template>
    <div class="loader-wrapper" v-if="loading">
      <div class="loader"></div>
    </div>
    <section class="authentication-form" v-else>
      <div class="innerpage-decor">
        <div class="innerpage-circle1"><img :src='"../assets/images/Testimonial2.png"' alt=""></div>
        <div class="innerpage-circle2"><img :src='"../assets/images/Testimonial1.png"' alt=""></div>
      </div>
      <div>
        <h2 class="title text-center"><span>Self Service</span></h2>
        <p class="text-center">Welcome to FMC Ebutte Metta, Self Service Payment.</p>
        <div class="card shadow">
          <img class="img-logo mx-auto" :src='"../assets/images/fmce-logo.png"' alt="">
          <form class="theme-form" @submit.prevent="submit" novalidate="novalidate" autocomplete="false">
            <div class="form-group">
              <input type="number" min="0" class="form-control text-uppercase text-center" placeholder="Enter Patient Number Here" v-model.trim="$v.patientNo.$model">
              <template v-if="$v.patientNo.$error">
                <span
                  class="form-text text-danger text-center"
                  v-if="!$v.patientNo.required"
                >
                  Please your patient number to get started.
                </span>
              </template>
            </div>
            <div class="form-button text-center">
              <button type="submit" class="btn btn-custom btn-lg btn-block theme-color">Continue</button>
            </div>
          </form>
        </div>
      </div>
    </section>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { mapGetters, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { GET_PATIENT } from '@/store/welcome.module'

export default {
  name: 'Welcome',
  data () {
    return {
      patientNo: '',
      loading: false
    }
  },
  validations: {
    patientNo: { required }
  },
  computed: {
    ...mapState({
      errors: (state) => state.welcome.errors
    }),
    ...mapGetters(['currentPatient'])
  },
  mounted () {},
  methods: {
    async submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true

        this.$store.dispatch(GET_PATIENT, this.patientNo)
          .then(() => {
            this.patientNo = ''
            this.loading = false

            this.$nextTick(() => {
              this.$v.$reset()
            })

            this.$router.push({ name: 'Menu' })
          })
          .catch(() => {
            this.$swal({
              title: 'Invalid Patient Number',
              text: 'Patient Was Not Found',
              icon: 'warning',
              heightAuto: false
            })
            this.loading = false
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/welcome.vue